
import { defineComponent } from "vue";
import ContactUsVue from "@/components/ContactUs.vue";
export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "contact-us",
  components: {
    ContactUsVue,
  },
});
